import api from 'service/api'

const dponetAPI = api.create('dponet')

const list = async () => {
  return await dponetAPI.get(`/security_measure_categories`)
}

export default { list }
